// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__a8j7z","header":"PatientQuestionnaire_header__2PVsu","info":"PatientQuestionnaire_info__WZ2uR"};